<template>
	<div id="TeamSignUp">
		<p class="title">团队信息：</p>
		<div class="list">
			<div class="list_left">
				<!-- <span style="color: #f00;">*</span> -->
				<span>团队名称</span>
			</div>
			<input type="text" v-model="form.TeamName" placeholder="请输入团队名称">
		</div>
		<div class="list">
			<div class="list_left">
				<!-- <span style="color: #f00;">*</span> -->
				<span>所属机构</span>
			</div>
			<input type="text" v-model="form.TeamOrg" placeholder="请输入所属机构">
		</div>
		<p class="title" style="margin-top: 20px;">成员信息：</p>


		<div class="Members">
			<div class="Members_list" v-for="(item,index) of form.MemberMobiles">
				<p class="list" style="margin-top: 20px;"><span>{{index == 0?'队长:':'成员'+index+':'}}</span></p>
				<div class="list" v-if="index == 0" style="margin-top: 0;">
					<div class="list_left">
						<span>手机号码</span>
					</div>
					<input style='width:190px;' disabled maxlength="11" @change="changePhone(index,item.phone)" v-model="item.phone"
					 placeholder="请输入内容" />
				</div>
				<div class="list" v-if="index != 0" style="margin-top: 0;">
					<div class="list_left">
						<span>手机号码</span>
					</div>
					<input style='width:190px;' maxlength="11" @change="changePhone(index,item.phone)" v-model="item.phone"
					 placeholder="请输入内容" />
				</div>
				<div class="list">
					<div class="list_left">
						<span>名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称</span>
					</div>
					<input style='width: 190px;' v-model="names[index].name" disabled placeholder="请输入手机号获取" />
				</div>
			</div>
		</div>
		<div style="height: 40px;"></div>
		<div class="operation" @click="save()">
			报名
		</div>
	</div>
</template>

<script>
	import {
		Indicator,
		MessageBox
	} from 'mint-ui';
	export default {
		data() {
			return {
				form: {
					TeamName: '',
					TeamOrg: '',
					MemberMobiles: [{
						phone: ''
					}, {
						phone: ''
					}, {
						phone: ''
					}, {
						phone: ''
					}]
				},
				names: [{
					name: ''
				}, {
					name: ''
				}, {
					name: ''
				}, {
					name: ''
				}]
			}
		},
		created() {
			this.getmember()
		},
		methods: {
			getmember() {
				this.$http.get('/api/member/GetMember')
					.then(res => {
						console.log(res)
						this.form.MemberMobiles[0].phone = res.data.data.Mobile
						this.changePhone(0, res.data.data.Mobile)
					})
					.catch(error => {
						console.log(error)
					})
			},
			changePhone(index, value) {
				console.log(index, value)
				for (let x in this.form.MemberMobiles) {
					console.log(this.form.MemberMobiles)
					if (index == x) {

					} else {
						if (this.form.MemberMobiles[x].phone == value) {

							MessageBox('提示', '手机号不能重复');
							this.form.MemberMobiles[index].phone == ''
						}

					}

				}
				this.$http.get('/api/member/GetUserByMobile?mobile=' + value)
				.then(res => {
					console.log(res)
					if (res.data.Success) {
						this.names[index].name = res.data.data.UserName
					} else {
						MessageBox('提示', res.data.ErrorMsg);
					}

				})
				.catch(error => {
					console.log(error)
				})
			},
			save(){
				console.log(this.form)
				this.$http.post('/api/team/CreatTeam',this.form)
				.then(res => {
						console.log(res)
						if(res.data.Success){
							MessageBox('提示', '报名成功,请用电脑浏览器访问http://beijing.top10fp.com进行答题!');
							this.$router.push('/myTeam')
							var competition_info = JSON.parse(localStorage.getItem('competition_info'))
							competition_info.RegistType = 1
							localStorage.setItem("competition_info",JSON.stringify(competition_info))
						}else{
							MessageBox('提示',res.data.ErrorMsg);
						}
						
				})
				.catch(error => {
				  console.log(error)
				})
			}
		}

	}
</script>

<style scoped="scoped" lang="scss">
	#TeamSignUp {
		padding: 1rem 0.8rem;
		box-sizing: border-box;

		.operation {
			position: fixed;
			width: 100%;
			height: 40px;
			line-height: 40px;
			background: #3E1976;
			bottom: 0;
			left: 0;
			color: #fff;
			text-align: center;
		}

		.title {
			font-size: 1rem;
			font-weight: 600;
		}

		.list {
			display: flex;
			align-items: center;
			font-size: 0.9rem;
			margin-top: 10px;

			.list_left {
				margin-right: 10px;
			}

			input {
				flex: 1;
				height: 2rem;
				line-height: 2rem;
				border: none;
				border: 1px solid #dbdcdd;
				padding: 0 0.5rem;
				border-radius: 5px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/TeamSignUp.vue